export const LOT_STATUSES_LIST = [
    { value: "published", text: "извещение опубликовано" },
    { value: "in_progress", text: "идут торги" },
    { value: "finished_calculate_report", text: "подведение итогов" },
    { value: "finished", text: "окончен" },
    { value: "did_not_take_place", text: "не состоялся" },
    { value: "canceled", text: "отменен организатором" },
    { value: "suspended", text: "приостановлен" },
    { value: "draft", text: "черновик", roles: ['organizer', 'operator', 'admin'] },
];
export const LOT_REQUEST_STATUSES = {
    docs_requested: "Загрузка документов",
    requested: "Утверждение заявки",
    accepted: "Участие подтверждено",
    rejected: "Заявка отклонена",
};

export const LOT_STATUS_BADGE_SETTINGS = {
    draft: {variant: 'secondary', title: 'Черновик'},
    published: {variant: 'info', title: 'Извещение опубликовано'},
    in_progress: {variant: 'primary', title: 'Идут торги'},
    finished_calculate_report: {variant: 'warning', title: 'Подведение итогов'},
    finished: {variant: 'success', title: 'Окончен'},
    did_not_take_place: {variant: 'secondary', title: 'Не состоялся'},
    suspended: {variant: 'secondary', title: 'Торги приостановлены'},
    canceled: {variant: 'secondary', title: 'Отменен организатором'},
}